import client from './client';

export const downloadTimesheetDeadlineReport = async (
  payPeriodID: number | string,
  fileName?: string
): Promise<void> => {
  const response = await client.get('/admin/riceServices/reports/weeklyTimesheetDeadlineReport', {
    params: { payPeriodID },
    responseType: 'blob',
  });

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName ?? `TimesheetDeadlineReport_${payPeriodID}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
